import { ThunkDispatch } from "redux-thunk";
import { loadAndTrack } from "redux-request-loading";
import { Payload } from "@neworbit/redux-helpers";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

import { navigateToParentRoute } from "@teamprevent/common/routing/actions";
import { trackException } from "@teamprevent/common/logging/trackException";
import { Appointment } from "@teamprevent/common/calendar";
import { toast } from "@teamprevent/common/toasts";

import { bookAdHocAppointmentError } from "../../bookAppointments/actions";
import { AdHocCalendarAppointmentModel, ApplicationState } from "../../bookAppointments/models";

import { TimeNoteAppointmentsApi } from "./timeNoteAppointmentsApi";
import * as actions from "./actionTypes";

export type CreateTimeNoteAppointmentSuccess = ({ type: typeof actions.CREATE_TIME_NOTE_APPOINTMENT_SUCCESS }) & Payload<Appointment>;
export type UpdateTimeNoteAppointmentSuccess = ({ type: typeof actions.UPDATE_TIME_NOTE_APPOINTMENT_SUCCESS }) & Payload<Appointment>;

export type TimeNoteAppointmentAction =
    CreateTimeNoteAppointmentSuccess |
    UpdateTimeNoteAppointmentSuccess;

export const createTimeNoteAppointment = (appointment: AdHocCalendarAppointmentModel) => {
    return async (dispatch: ThunkDispatch<ApplicationState, undefined, any>) => {
        try {
            const result = await loadAndTrack(
                dispatch,
                actions.CREATE_TIME_NOTE_APPOINTMENT,
                new TimeNoteAppointmentsApi().createTimeNoteAppointment(appointment));
            if (result.success === true) {
                dispatch(createTimeNoteAppointmentSuccess(result.appointment));
                dispatch(navigateToParentRoute());
                toast.success("Appointment created successfully");
            } else {
                dispatch(bookAdHocAppointmentError(result.errors));
            }
        } catch (e) {
            trackException(e, SeverityLevel.Warning);
            toast.error("Time Note Appointment creation failed");
        }
    };
};

export const updateTimeNoteAppointment = (timeNoteId: string, clinicId: string | undefined, appointment: AdHocCalendarAppointmentModel) => {
    return async (dispatch: ThunkDispatch<ApplicationState, undefined, any>) => {
        try {
            const result = await loadAndTrack(
                dispatch,
                actions.UPDATE_TIME_NOTE_APPOINTMENT,
                new TimeNoteAppointmentsApi().updateTimeNoteAppointment(timeNoteId, clinicId, appointment));
            if (result.success === true) {
                dispatch(updateTimeNoteAppointmentSuccess(result.appointment));
                dispatch(navigateToParentRoute());
                toast.success("Appointment updated successfully");
            } else {
                dispatch(bookAdHocAppointmentError(result.errors));
            }
        } catch (e) {
            trackException(e, SeverityLevel.Warning);
            toast.error("Time Note Appointment update failed");
        }
    };
};

export const createTimeNoteAppointmentSuccess = (payload: Appointment): CreateTimeNoteAppointmentSuccess => ({
    payload,
    type: actions.CREATE_TIME_NOTE_APPOINTMENT_SUCCESS
});

export const updateTimeNoteAppointmentSuccess = (payload: Appointment): UpdateTimeNoteAppointmentSuccess => ({
    payload,
    type: actions.UPDATE_TIME_NOTE_APPOINTMENT_SUCCESS
});
